<template>
    <v-layout>
        <app-toolbar></app-toolbar>
        <v-slide-x-reverse-transition hide-on-leave>
            <router-view></router-view>
        </v-slide-x-reverse-transition>
    </v-layout>
</template>
<script>
import AppToolbar from "@/components/Toolbar";
export default {
    name: "Home",
    components: {
        AppToolbar
    }
};
</script>
